import Vue from 'vue';
import VueI18n from 'vue-i18n'

import sv from '@/../lang/sv';
import vuetifySv from 'vuetify/es5/locale/sv';
import en from '@/../lang/en';
import vuetifyEn from 'vuetify/es5/locale/en';
import de from '@/../lang/de';
import vuetifyDe from 'vuetify/es5/locale/de';
import fr from '@/../lang/fr';
import vuetifyFr from 'vuetify/es5/locale/fr';
import es from '@/../lang/es';
import vuetifyEs from 'vuetify/es5/locale/es';
import pt from '@/../lang/pt';
import vuetifyPt from 'vuetify/es5/locale/pt';

Vue.use(VueI18n);

const messages = {
  sv: {
    ...sv,
    $vuetify: {
      ...vuetifySv
    }
  },
  en: {
    ...en,
    $vuetify: {
      ...vuetifyEn
    }
  },
  de: {
    ...de,
    $vuetify: {
      ...vuetifyDe
    }
  },
  fr: {
    ...fr,
    $vuetify: {
      ...vuetifyFr
    }
  },
  es: {
    ...es,
    $vuetify: {
      ...vuetifyEs
    }
  },
pt: {
    ...pt,
    $vuetify: {
      ...vuetifyPt
    }
  }
}

const i18n = new VueI18n({
  locale: document.documentElement.lang,
  messages,
  silentTranslationWarn: false
});

export default i18n;